import { useEffect, useState, useRef } from 'react';
import MasterPage from '../../../EstruturaAntiga/masterpages/authenticated';
import { Button, Table, Pagination, Flex, Input, Empty, Tooltip } from "antd";
import { LoadingOutlined, PlusOutlined, EditOutlined, DeleteOutlined, DollarOutlined, UnlockOutlined, LockOutlined, UsergroupAddOutlined, SafetyOutlined } from '@ant-design/icons';
import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import UsuariosService from 'services/UsuariosService';
import getUsuarioStatusCode from 'EstruturaAntiga/actions/usuarios/getUsuarioStatusCode';
import CONSTANTES_AMBIENTE from 'constants/constantesAmbiente';
import ListasPrecoService from 'services/ListasPrecoService';
import { withRouter } from 'react-router-dom';
import { rdxSetEditUser } from 'EstruturaAntiga/pages/usuariosV2/redux/usuariosActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AlterarSenha from 'EstruturaAntiga/pages/usuariosV2/componentes/AlterarSenha';
import RedefinirMFA from 'EstruturaAntiga/pages/usuariosV2/componentes/RedefinirMFA';
import { mapUserFieldsV2toV1 } from 'EstruturaAntiga/assets/userHelpers';
import AssessoresService from 'services/AssessoresService';
import { NotificationManager } from 'react-notifications';
import LoadingShadow from 'EstruturaAntiga/components/loadingShadow';
import DeleteUser from 'EstruturaAntiga/pages/usuariosV2/componentes/deleteUser';
import BloquearDesbloquearEntrada from 'EstruturaAntiga/pages/usuariosV2/componentes/BloquearDesbloquearEntrada';
import ModalAdvisorXpBlue3CannotBeDisabled from 'EstruturaAntiga/pages/usuariosV2/componentes/ModalAdvisorXpBlue3CannotBeDisabled';
import { getFormId } from 'EstruturaAntiga/pages/usuariosV2/componentes/Uteis';
import ObjectUtils from 'utils/objects';
import ArrayUtils from 'utils/arrays';
import LayoutUtils from 'utils/layout';
import { useWindowSize } from 'store/useWindowSize';
import { usePagination } from 'store/usePagination';
import { STATUS_CODE } from 'constants/statusCodes';
import { useRoteiro } from 'context/RoteiroContext';
import { useAuth } from 'context/AuthContext';
import ExclusaoUsuariosSelecionados from '../ExclusaoUsuariosSelecionados';
import PerfisDeAcessoService from 'services/PerfisDeAcessoService';
import { ModalErro } from 'components/Modais/ModalErro';
import useBloquearDesbloquearEntrada from 'hooks/useBloquearDesbloquearEntrada';
import FormulariosEntidadeService from 'services/FormulariosEntidadeService';
import { ModalInformativo } from 'components/Modais/ModalInformativo';
import { obterBloqueio, obterBloqueioAlteracaoPlano } from 'utils/bloqueios';
import { FuncionalidadePortalCliente } from 'constants/funcionalidadePortalCliente';

function ListagemUsuarios({ history, rdxSetEditUser }) {
    const {ValidaPermissaoAcessoRota, tenant, direito} = useAuth();
    const [desabilitarFuncoesUsuario, setDesabilitarFuncoesUsuario] = useState(true);
    const [habilitarBloqueioDesbloqueioDeUsuario, setHabilitarBloqueioDesbloqueioDeUsuario] = useState(true);
    const [bloqueioNovoUsuario, setBloqueioNovoUsuario] = useState({ bloqueado: false, mensagem: '' });
    const [bloqueioAlteracaoPlano, setBloqueioAlteracaoPlano] = useState({ entradaBloqueada: false, mensagem: '' });
    const [desabilitarExclusaoUsuarios, setDesabilitarExclusaoUsuarios] = useState(true);
    const [erro, setErro] = useState({temErro: false, mensagens: ''});
    const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
    const [statusUsuarios, setStatusUsuarios] = useState([]);
    const [produtosUsuarios, setProdutosUsuarios] = useState([]);
    const [carregandoStatusUsuarios, setCarregandoStatusUsuarios] = useState(true);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState({});
    const [modal, setModal] = useState('');
    const { Search } = Input;
    const {alturaTotalTela} = useWindowSize();
    
    const {setReferenciaObjetosVisuais} = useRoteiro();
    const refBotaoNovoUsuario = useRef(null);
    const refTabelaUsuarios = useRef(null);
    const refFiltroUsuarios = useRef(null);
    const refPaginacaoUsuarios = useRef(null);
    const refBotoesUsuarios = useRef(null);
    const refBotaoCriarMultiplos = useRef(null);
    const refBotaoBloquearUsuario = useRef(null);

    const refs = [
        { id: 'refBotaoNovoUsuario', ref: refBotaoNovoUsuario },
        { id: 'refFiltroUsuarios', ref: refFiltroUsuarios },
        { id: 'refTabelaUsuarios', ref: refTabelaUsuarios },
        { id: 'refPaginacaoUsuarios', ref: refPaginacaoUsuarios },
        { id: 'refBotaoBloquearUsuario', ref: refBotaoBloquearUsuario },
        { id: 'refBotaoCriarMultiplos', ref: refBotaoCriarMultiplos }
    ];

    const listarUsuarios = async (tamanhoPagina = 10, filtro = '', skipToken = '') =>{
        const response = await UsuariosService.NovoListarUsuarios(skipToken, filtro, tamanhoPagina);
        if(!response) return;
    
        response.users.forEach(usuario => {
            usuario.status = <LoadingOutlined />;
            usuario.plano = <LoadingOutlined />;
        });
    
        return response;
    }

    const {
        dados: usuarios,
        handleAlteracaoDePaginacao,
        executarFetchData,
        paginacaoLoading,
        paginacaoErro,
        paginacaoOpcoes,
        filtroAplicado,
        setDados: setUsuarios,
        setPaginasArmazenadas,
        handleFiltro,
        setPaginacaoLoading,
        resetarPaginacao
    } = usePagination(listarUsuarios, 'users', false);

    const usuarioBloqueadoProps = useBloquearDesbloquearEntrada({
        userId : usuarioSelecionado?.id,
        nomeUsuario: usuarioSelecionado?.displayName,
        contaEstaAtiva: usuarioSelecionado?.accountEnabled,
        onCloseModal: (mudancaStatusUsuario) => onCloseModalBloquearEntradaUsuario(mudancaStatusUsuario)
    });

    const LayoutHeights = {
        header: 92,
        footer: 90,
        containerPadding: 32,
        innerHeader: 60,
        tableTitle: 60
    }

    useEffect(()=>{
        inicializarListagem();
    }, []);

    useEffect(()=>{
        if (!paginacaoLoading){
            carregarStatusUsuarios();
        }
    }, [paginacaoLoading]);

    useEffect(()=>{
        atualizarStatusUsuarios();
        atualizarPaginasArmazenadasComNovosStatus();
    }, [statusUsuarios]);

    useEffect(()=>{
        if (!carregandoStatusUsuarios){
            carregarProdutosUsuarios();
        }
    }, [carregandoStatusUsuarios, paginacaoOpcoes]);

    useEffect(()=>{
        atribuirPlanosUsuariosNoStateUsuarios();
        atribuirPlanosUsuariosNoStatePaginasArmazenadas();
    }, [produtosUsuarios]);

    useEffect(()=>{
        definirDesabilitacaoDasFuncoesDoUsuario();
        definirDesabilitacaoDaExclusaoDeUsuarios();
    }, [usuarios, linhasSelecionadas]);

    const inicializarListagem = async () => {
        if (!await validarSeGestaoUsuariosEstaHabilitada()) return;
        await carregarConfiguracaoFormulario();
        await executarFetchData();
        setReferenciaObjetosVisuais(refs);
    }

    const carregarConfiguracaoFormulario = async () => {
        const configuracao = await FormulariosEntidadeService.ObterConfiguracaoFormulario()
            .catch(() => ({ habilitarBloqueioDesbloqueioDeUsuario: false }));
        setHabilitarBloqueioDesbloqueioDeUsuario(configuracao?.habilitarBloqueioDesbloqueioDeUsuario ?? true);
        const { bloqueado, mensagem } = obterBloqueio(configuracao, FuncionalidadePortalCliente.CriacaoUsuario);
        setBloqueioNovoUsuario({ bloqueado, mensagem });
        const { entradaBloqueada, mensagem: mensagemAlteracaoPlano } = obterBloqueioAlteracaoPlano(configuracao);
        setBloqueioAlteracaoPlano({ entradaBloqueada, mensagem: mensagemAlteracaoPlano });
    }

    const validarSeGestaoUsuariosEstaHabilitada = async () => {
        await UsuariosService.ValidarHabilitacaoGestaoUsuarios()
            .catch(error =>{
                setErro({
                    temErro: true, 
                    mensagens: error.response?.data?.erros ?? 'Erro inesperado ao obter direito para verificar se a gestão de usuários está habilitada.'
                });
                setPaginacaoLoading(false);
                return false;
            });
        return true;
    }

    const rowSelectionOnChange = (newSelectedRowKeys, selectedRows) => {
        setLinhasSelecionadas(newSelectedRowKeys);
        setUsuarioSelecionado(selectedRows[0]);
    };

    const rowSelectionOnClick = (newSelectedRowKeys, selectedRows) => {
        const clickedKey = newSelectedRowKeys[0];
        const clickedRow = selectedRows[0];

        setLinhasSelecionadas(prev => {
            const jaSelecionado = prev.includes(clickedKey);
            if (jaSelecionado) {
                setUsuarioSelecionado({});
                return prev.filter(key => key !== clickedKey);
            } else {
                setUsuarioSelecionado(clickedRow);
                return [...prev, clickedKey];
            }
        });
    };

    const rowSelection = {
        type: 'checkbox',
        selectedRowKeys: linhasSelecionadas,
        onChange: rowSelectionOnChange
    };

    const colunasTabelaUsuario = [
        {
            title: 'Nome',
            dataIndex: 'displayName',
            key: 'displayName',
            width: '100px',
            ellipsis: true
        },
        {
            title: 'Login',
            dataIndex: 'userPrincipalName',
            key: 'userPrincipalName',
            width: '200px',
            ellipsis: true
        },
        {
            title: 'E-mail',
            dataIndex: 'mail',
            key: 'mail',
            width: '200px',
            ellipsis: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '50px',
            ellipsis: true
        },
        {
            title: 'Plano',
            dataIndex: 'plano',
            key: 'plano',
            width: '100px',
            ellipsis: true
        }
    ];

    const paginacaoOnChange = (paginaAtual, tamanhoPagina) =>{
        setLinhasSelecionadas([]);
        setUsuarioSelecionado({});
        handleAlteracaoDePaginacao(paginaAtual, tamanhoPagina);
    }

    const onSearch = (valorFiltro) =>{
        setLinhasSelecionadas([]);
        setUsuarioSelecionado({});
        handleFiltro(valorFiltro);
    }

    const carregarStatusUsuarios = async () => {
        setCarregandoStatusUsuarios(true);

        const lotesUsuarios = ArrayUtils.splitIntoBatches(usuarios, 10);
        for (const lote of lotesUsuarios) {
            const resultados = await Promise.all(
                lote.map(async (usuario) => {
                    if (!statusUsuarios.some(x => x.axt_idobjetousuario365 === usuario.id)) {
                        const resultado = await getUsuarioStatusCode(usuario.id);
                        if (!resultado) return null;
                        if (resultado?.statuscode === 204) {
                            resultado.axt_idobjetousuario365 = usuario.id;
                        }
                        return resultado;
                    }
                    return null;
                })
            );

            const novosStatus = resultados.filter(status => status !== null);
    
            setStatusUsuarios(prevStatusUsuarios => [...prevStatusUsuarios, ...novosStatus]);
        }
        setCarregandoStatusUsuarios(false);
    };

    const carregarProdutosUsuarios = async () => {
        var tenantId = direito.axtTenantId;
        var direitoId = direito.entitlementId;
        var modeloDeOfertaCodigo = tenant.modeloOferta;
        const lotesUsuarios = ArrayUtils.splitIntoBatches(usuarios, 10);
        for (const lote of lotesUsuarios) {
            const resultados = await Promise.all(
                lote.map(async (usuario) => {
                    if (!produtosUsuarios.some(x => x.usuarioId === usuario.id)) {
                        const userProduct = await ListasPrecoService.ListarProdutosPorLicencaAtribuida(
                                tenantId,
                                direitoId,
                                modeloDeOfertaCodigo,
                                usuario.assignedLicenses
                            );
                        return { produtos: userProduct, usuarioId: usuario.id };
                    }
                    return null;
                })
            );

            const novosProdutos = resultados.filter(produto => produto !== null);

            setProdutosUsuarios(prevProdutosUsuarios => [...prevProdutosUsuarios, ...novosProdutos]);
        }
    };

    const obterTextoStatusUsuario = (usuarioBloqueado, razaoStatus) => {
        if(razaoStatus === CONSTANTES_AMBIENTE.TIPOS_STATUS_USUARIOS.EM_SINCRONIZACAO)
            return CONSTANTES_AMBIENTE.ARRAY_STATUS_USUARIOS.find(status => status.code == CONSTANTES_AMBIENTE.TIPOS_STATUS_USUARIOS.EM_SINCRONIZACAO)?.status
        
        return usuarioBloqueado ? 'Bloqueado' : CONSTANTES_AMBIENTE.ARRAY_STATUS_USUARIOS.find(status => status.code == CONSTANTES_AMBIENTE.TIPOS_STATUS_USUARIOS.ATIVO)?.status;
    };

    const atribuirStatusUsuarios = (usuarios) => {
        return usuarios.map((usuario) => {
            const statusUsuario = statusUsuarios.find(x => x.axt_idobjetousuario365 === usuario.id);
            return { ...usuario, status: obterTextoStatusUsuario(!usuario.accountEnabled, statusUsuario?.statuscode)};
        });
    }
    
    const atualizarStatusUsuarios = async () => {
        if (statusUsuarios.length <= 0) return;

        const novosDados = atribuirStatusUsuarios(usuarios);
        setUsuarios(novosDados);
    }

    const atualizarPaginasArmazenadasComNovosStatus = async () => {
        if (statusUsuarios.length <= 0) return;

        setPaginasArmazenadas((prevPaginasArmazenadas) => {
          const novoCache = Object.fromEntries(
            Object.entries(prevPaginasArmazenadas).map(([pagina, usuarios]) => [
              pagina,
              atribuirStatusUsuarios(usuarios),
            ])
          );     
          return novoCache;
        });
    };

    const atribuirPlanosUsuarios = (usuarios) => {
        return usuarios.map((usuario) => {
            const produtosUsuario = produtosUsuarios.find(x => x.usuarioId === usuario.id);
            if (!produtosUsuario) return usuario;
    
            const planoPrincipal = produtosUsuario?.produtos?.find(produto => produto.estruturaProduto === 3)?.produto;
            return { ...usuario, plano: planoPrincipal ? planoPrincipal : '' };
        });
    }

    const atribuirPlanosUsuariosNoStateUsuarios = async () => {
        if (produtosUsuarios.length <= 0) return;

        const novosDados = atribuirPlanosUsuarios(usuarios)
        setUsuarios(novosDados);
    }

    const atribuirPlanosUsuariosNoStatePaginasArmazenadas = async () => {
        if (produtosUsuarios.length <= 0) return;

        setPaginasArmazenadas((prevPaginasArmazenadas) => {
          const novoCache = Object.fromEntries(
            Object.entries(prevPaginasArmazenadas).map(([pagina, usuarios]) => [
              pagina,
              atribuirPlanosUsuarios(usuarios)
            ])
          );     
          return novoCache;
        });
    };

    const reduxSetEditarUsuario = () => {
        const dadosEdicao = {
            contact: usuarioSelecionado,
            displayName: usuarioSelecionado.displayName,
            mail: usuarioSelecionado.mail,
            userPrincipalName: usuarioSelecionado.userPrincipalName,
            accountEnabled: usuarioSelecionado.accountEnabled,
            isSync: usuarioSelecionado.axt_onpremisessyncenabled,
            key: usuarioSelecionado.userPrincipalName,
            usuarioId: usuarioSelecionado.id
        }
        rdxSetEditUser(dadosEdicao);
    }

    const onClickNovoUsuario = () => {
        if (bloqueioNovoUsuario.bloqueado) {
            ModalInformativo('Criação de usuários indisponível', bloqueioNovoUsuario.mensagem);
            return;
        }
        history.push('/usuarios/novo');
    }

    const onClickAdicionarVarios = () => {
        if (bloqueioNovoUsuario.bloqueado) {
            ModalInformativo('Criação de usuários indisponível', bloqueioNovoUsuario.mensagem);
            return;
        }
        history.push('/usuarios/criarmultiplos');
    }

    const onClickEditarUsuario = () => {
        if (desabilitarFuncoesUsuario) {
            return;
        }
        reduxSetEditarUsuario();
        history.push(`/usuarios/editar`);
    }

    const onClickAlterarPlano = () => {
        if (desabilitarFuncoesUsuario) {
            return;
        }
        if (bloqueioAlteracaoPlano.entradaBloqueada) {
            ModalInformativo('Alteração de plano indisponível', bloqueioAlteracaoPlano.mensagem);
            return;
        }
        reduxSetEditarUsuario();
        history.push(`/usuarios/alterarPlano`);
    }

    const onClickBloquearOuDesbloquearUsuario = () => {
        if (desabilitarFuncoesUsuario) return;        
        setModal('bloquear-desbloquear-entrada-usuario');
    }

    const onCloseModal = () => {
		setModal('');
	}

    const onCloseModalExcluirUsuario = async (deletedUser = false) => {
        if(deletedUser){
            setLinhasSelecionadas([]);
            setUsuarioSelecionado({});
            resetarPaginacao();
			executarFetchData();
		}
		onCloseModal();
	}

    const onCloseModalBloquearEntradaUsuario = async (mudancaStatusUsuario = false) => {
        setUsuarioSelecionado({});
        setLinhasSelecionadas([]);
        if (mudancaStatusUsuario) {           
            resetarPaginacao();
            await executarFetchData();
        }
        onCloseModal();
    }

    const onClickAlterarSenha = () => {
        if (desabilitarFuncoesUsuario) {
            return;
        }
        setModal('alterar-senha');
    }

    const onClickRedefinirMFA = () => {
        if (desabilitarFuncoesUsuario) {
            return;
        }
        setModal('redefinir-mfa');
    }

    const excluirUsuario = async () => {

        setModal('excluir-usuario')
    }

    const onClickExcluirUsuario = async () => {
        if (desabilitarFuncoesUsuario && desabilitarExclusaoUsuarios) {
            return;
        }
        setModal('shadow');

        await processarExclusao();
	}

    const processarExclusao = async () => {
        if (linhasSelecionadas.length > 1) {
            await processarExclusaoMultiplos();
        } else {
            await processarExclusaoUsuario();
        }
    }

    const processarExclusaoMultiplos = async () => {

            setModal('excluir-usuarios-selecionados');
    }

    const processarExclusaoUsuario = async () => {
        if (getFormId() == CONSTANTES_AMBIENTE.FORMULARIO_USUARIOS.XP || getFormId() == CONSTANTES_AMBIENTE.FORMULARIO_USUARIOS.BLUE3) {
            const user = await UsuariosService.ObterUsuario(usuarioSelecionado.id)
                .then(obj => mapUserFieldsV2toV1(obj));
            let advisorUserCode = user?.axt_extensionattribute5;

            if (advisorUserCode) {
                AssessoresService.PodeSerDespadronizado(advisorUserCode)
                    .then((response) => {
                        if (response && response.canBeDisabled) {
                            excluirUsuario();
                        } else {
                            setModal('alert-advisor-xp-cannot-be-disabled');
                        }
                    })
                    .catch(() => {
                        onCloseModal();
                        NotificationManager.error(
                            "Favor tentar novamente ou entre em contato com seu gestor.",
                            "Não foi possivel excluir o usuário!",
                            7000
                        );
                    });
            } else {
                excluirUsuario();
            }
        } else {
            excluirUsuario();
        }
    }

    const renderModal = () => {
        if (modal === 'shadow') {
            return (
                <LoadingShadow
                    sizeClassName={''}
                    open={true} 
                    close={() => {}}
                />
            )
        } else if (modal === 'alterar-senha') {
            return (
                <AlterarSenha
                    onCloseModal={onCloseModal.bind(this)}
                    upn={usuarioSelecionado.userPrincipalName || usuarioSelecionado.mail}
                    sync={usuarioSelecionado.axt_onpremisessyncenabled || false}
                />
            )
        } else if (modal === 'redefinir-mfa') {
            return (
                <RedefinirMFA
                    onCloseModal={onCloseModal.bind(this)}
                    usuarioId={usuarioSelecionado.id}
                />
            )
        } else if (modal === "excluir-usuario") {
            return (
                <DeleteUser
                    onCloseModal={onCloseModalExcluirUsuario.bind(this)}
                    userId={usuarioSelecionado.id}
                />
            );
        } else if (modal === "alert-advisor-xp-cannot-be-disabled") {
            return (
                <ModalAdvisorXpBlue3CannotBeDisabled onCloseModal={onCloseModal.bind(this)}/>
            );
        } else if (modal === 'excluir-usuarios-selecionados') {
            return (
                <ExclusaoUsuariosSelecionados
                    onCancel={onCloseModalExcluirUsuario.bind(this)}
                    usuarios={usuarios}
                    usuarioIds={linhasSelecionadas}
                    obterAlturaDisponivelNaTela={obterAlturaDisponivelNaTela}
                />
            );
        } else if (modal === "bloquear-desbloquear-entrada-usuario") {
            return (
                <BloquearDesbloquearEntrada {...usuarioBloqueadoProps} />
            );
        }
    }

    const definirDesabilitacaoDaExclusaoDeUsuarios = () => {
        if (linhasSelecionadas.length > 1) {
            setDesabilitarExclusaoUsuarios(false);
        }
        else {
            setDesabilitarExclusaoUsuarios(true);
        }
    }

    const definirDesabilitacaoDasFuncoesDoUsuario = () => {
        if (ObjectUtils.ObjetoEhVazio(usuarioSelecionado) || ObjectUtils.objetoInvalido(usuarioSelecionado)) {
            return setDesabilitarFuncoesUsuario(true);
        }

        if (linhasSelecionadas.length > 1) {
            return setDesabilitarFuncoesUsuario(true);
        }
    
        const statusUsuario = statusUsuarios.find(x => x.axt_idobjetousuario365 === usuarioSelecionado?.id);
        if(statusUsuario?.statuscode === CONSTANTES_AMBIENTE.TIPOS_STATUS_USUARIOS.EM_SINCRONIZACAO){            
                return setDesabilitarFuncoesUsuario(true);
        }
    
        return setDesabilitarFuncoesUsuario(false);
    };

    const retornarMensagemErro = () => {
        if (paginacaoErro.temErro || erro.temErro) {
            if (paginacaoErro.statuscode === STATUS_CODE.UNAUTHORIZED || paginacaoErro.statuscode === STATUS_CODE.FORBIDDEN) {
                return 'O Portal do Cliente não possui o consentimento de seu administrador para listar os usuários.';
            }
            if (erro.mensagens) {
                return erro.mensagens;
            }
            if (paginacaoErro.mensagens) {
                return paginacaoErro.mensagens;
            }
        }
        return '';
    };

    function obterAlturaDisponivelNaTela() {
        return LayoutUtils.ObterAlturaDisponivelEmTela(Object.values(LayoutHeights), alturaTotalTela);
    }

    return (
        <MasterPage useFullWidth={!paginacaoErro.temErro && !erro.temErro}>
            <LoadingOrErrorPanel nomeMenu={'Usuários'} loading={paginacaoLoading} hasError={paginacaoErro.temErro || erro.temErro} mensagemErro={retornarMensagemErro()}>
                {renderModal()}
                <Flex
                    justify='flex-start'
                    align='center'
                    style={{ height: '40px', background: '#f8f9fa', boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", margin: "10px 0", borderRadius:"5px", padding:"3px 10px" }}
                >
                    <div ref={refBotoesUsuarios} style={{ width:'fit-content' }}>
                        <Tooltip title={!ValidaPermissaoAcessoRota("/usuarios/novo")? "Indisponível" : null}>
                            <Button type="text" onClick={onClickNovoUsuario} style={{ marginRight: 8 }} ref={refBotaoNovoUsuario} disabled={!ValidaPermissaoAcessoRota("/usuarios/novo")}>
                                <PlusOutlined />Novo usuário
                            </Button>
                        </Tooltip>

                        <Tooltip title={!ValidaPermissaoAcessoRota("/usuarios/criarmultiplos")? "Indisponível" : null}>
                            <Button type="text" onClick={onClickAdicionarVarios} style={{ marginRight: 8 }} ref={refBotaoCriarMultiplos} disabled={!ValidaPermissaoAcessoRota("/usuarios/criarmultiplos")}>
                                <UsergroupAddOutlined />Adicionar vários
                            </Button>
                        </Tooltip>
                        
                        <Tooltip title={!ValidaPermissaoAcessoRota("/usuarios/editar")? "Indisponível" : null}>
                            <Button type="text" disabled={(!ValidaPermissaoAcessoRota("/usuarios/editar") || desabilitarFuncoesUsuario)} onClick={onClickEditarUsuario} style={{ marginRight: 8 }}>
                                <EditOutlined />Editar
                            </Button>
                        </Tooltip>

                        <Button type="text" disabled={desabilitarFuncoesUsuario} onClick={onClickAlterarSenha}  style={{ marginRight: 8 }}>
                            <UnlockOutlined />Redefinir senha
                        </Button>

                        <Button type="text" disabled={desabilitarFuncoesUsuario} onClick={onClickRedefinirMFA} style={{ marginRight: 8 }}>
                            <SafetyOutlined />Redefinir MFA
                        </Button>
                        {habilitarBloqueioDesbloqueioDeUsuario && (
                        <Tooltip title={!ValidaPermissaoAcessoRota("/usuarios/bloquear") ? "Indisponível" : null}>
                            <Button type="text" disabled={desabilitarFuncoesUsuario} onClick={onClickBloquearOuDesbloquearUsuario} ref={refBotaoBloquearUsuario} style={{ marginRight: 8 }}>
                                {!usuarioSelecionado?.accountEnabled ? (
                                    <>
                                        <UnlockOutlined /> Desbloquear Entrada
                                    </>) : (
                                    <>
                                        <LockOutlined /> Bloquear Entrada
                                    </>
                                )}
                            </Button>
                        </Tooltip>
                        )}
                        <Tooltip title={!ValidaPermissaoAcessoRota("/usuarios/alterarplano")? "Indisponível" : null}>
                            <Button type="text" disabled={(!ValidaPermissaoAcessoRota("/usuarios/alterarplano") || desabilitarFuncoesUsuario)} onClick={onClickAlterarPlano} style={{ marginRight: 8 }}>
                                <DollarOutlined />Alterar plano
                            </Button>
                        </Tooltip>

                        <Button
                            type="text"
                            danger
                            disabled={desabilitarFuncoesUsuario && desabilitarExclusaoUsuarios}
                            onClick={onClickExcluirUsuario}
                        >
                            <DeleteOutlined />Excluir
                        </Button>
                    </div>
                </Flex>
                <div ref={refTabelaUsuarios}>
                    <Table
                        rowKey={'id'}
                        dataSource={usuarios}
                        columns={colunasTabelaUsuario}
                        rowSelection={rowSelection} 
                        pagination={false}
                        size='small'
                        scroll={ usuarios.length > 0 ? { y: obterAlturaDisponivelNaTela() } : undefined }
                        bordered={false}
                        locale={{ emptyText: <Empty description={'Nenhum usuário encontrado'} image={Empty.PRESENTED_IMAGE_SIMPLE}/> }}
                        onRow={(record) => {
                            return {
                                onClick: () => {rowSelectionOnClick([record.id], [record])},
                                onDoubleClick: () => {onClickEditarUsuario()}
                            };
                        }}
                        title={() =>
                            <Flex justify='space-between' align= 'center' style={{ height: '44px' }}>
                                <h3 style={{ fontSize: '28px' }}>Usuários</h3>
                                <div ref={refFiltroUsuarios} >
                                    <Search
                                        placeholder={"Filtrar por nome ou e-mail"}
                                        onSearch={onSearch}
                                        allowClear
                                        style={{width: 235}}
                                        defaultValue={filtroAplicado}
                                    />
                                </div>
                            </Flex>
                        }
                        footer={() => 
                            <div ref={refPaginacaoUsuarios} style={{ width:'fit-content' }}>
                                <Pagination 
                                    defaultCurrent={1}
                                    simple={{ readOnly: true }}
                                    total={paginacaoOpcoes.total}
                                    showTotal={(total) => `Total: ${total}`}
                                    pageSize={paginacaoOpcoes.tamanhoPagina}
                                    onChange={paginacaoOnChange}
                                    disabled={paginacaoLoading}
                                    showSizeChanger={paginacaoOpcoes.total > 10}
                                    current={paginacaoOpcoes.paginaAtual}
                                    locale={{ items_per_page: '/ página' }}
                                />
                            </div>
                        }
                    />
                </div>
            </LoadingOrErrorPanel>
        </MasterPage>
    );
}

export default withRouter(connect(
    state => ({ 
        user: state.users.user
    }),
    (dispatch) => (bindActionCreators({
        rdxSetEditUser,
    }, dispatch))
)(ListagemUsuarios));